// Thin wrapper over a biometric-auth plugin, loaded dynamically so the web bundle
// (and any build without the plugin) keeps working. Everything degrades gracefully:
// if the plugin or hardware is absent, biometricAvailable() is false and
// biometricVerify() returns true (never locks the user out).

let _mod;

async function load() {
    if (_mod !== undefined) return _mod;
    try {
        _mod = await import("@aparajita/capacitor-biometric-auth");
    } catch {
        _mod = null;
    }
    return _mod;
}

export async function biometricAvailable() {
    try {
        const mod = await load();
        if (!mod?.BiometricAuth) return false;
        const info = await mod.BiometricAuth.checkBiometry();
        return !!info?.isAvailable;
    } catch {
        return false;
    }
}

export async function biometricVerify(reason = "Desbloquea QCapital") {
    try {
        const mod = await load();
        if (!mod?.BiometricAuth) return true; // no plugin installed → do not lock out
        await mod.BiometricAuth.authenticate({
            reason,
            cancelTitle: "Cancelar",
            allowDeviceCredential: true,
            iosFallbackTitle: "Usar codigo",
            androidTitle: "QCapital",
            androidSubtitle: "Verifica tu identidad",
        });
        return true;
    } catch {
        return false; // cancelled or failed
    }
}
